export default "__VITE_ASSET__BQY4x2BA__"